import { Chip, ChipProps } from '@mui/material';
import { useTranslation } from 'react-i18next';

export type UserStatusChipType = 'internal' | 'members' | 'pro';

type UserStatusChipProps = {
  type: UserStatusChipType;
};

const translationKeys: Record<UserStatusChipType, string> = {
  internal: 'internalChip.label',
  members: 'membersChip.label',
  pro: 'proChip.label',
};

export const UserStatusChip = ({
  type,
  color,
  ...props
}: UserStatusChipProps & ChipProps): JSX.Element => {
  const { t } = useTranslation();

  const chipTitle = t(translationKeys[type]);
  const colorForType = type === 'internal' ? 'error' : 'brand';

  return (
    <Chip
      {...props}
      label={chipTitle}
      color={color || colorForType}
      variant="watchduty"
      component="span"
      data-testid={`${type}-chip`}
    />
  );
};
